import { isAnswered } from "@memorang/helpers/item";
import type { BaseItemSchema } from "@memorang/types";
import useSessionStore from "./useSessionStore";

const useItemAnsweredState = (item: BaseItemSchema | undefined) => {
	const answers = useSessionStore((s) => s.answers);
	const isSummativeTest = useSessionStore((s) => s.isSummativeTest) ?? false;
	const inReviewMode = useSessionStore((s) => s.inReviewMode) ?? false;

	const currentAnswer = item?.id
		? answers?.get(item.id!) || item.answer
		: undefined;

	const isItemAnswered =
		inReviewMode || (!isSummativeTest && isAnswered(currentAnswer));

	return {
		isAnswered: isItemAnswered,
		inReviewMode,
		isSummativeTest,
	};
};

export default useItemAnsweredState;
